export const EVENT_TYPES = [
  "association",
  "chat",
  "coaching",
  "conference",
  "contest",
  "meeting",
  "networking",
  "podcast",
  "recruitment",
  "video",
  "visit",
  "workshop",
] as const

export const BO_EVENT_ATTENDANCE_FEATURE_FLAG = "event_attendance"
